import React, { ComponentType, createRef, PureComponent } from "react";
import html2canvas from "html2canvas";
import { withMsal } from "@azure/msal-react";

import DateRangePickerWrapper from "./DateRangePickerWrapper";
import ZoomModeSelector from "./ZoomModeSelector";
import {
  SettingsPanelContainerRow,
  SettingsSubPanelStyled,
  SettingsVerticalPanelStyled,
  SettingsPanelStyled,
  SettingsSpan,
  FlexItem,
  FlexItem22,
  FlexItem50,
  SettingsPanelContainerColumn,
  UserMenuTrigger,
  UserMenuContent,
  UserMenuItem,
  UserMenuLink
} from "../common/StyledComponents";
import { IconSettingsButton22x22, IconSettingsButton50x50 } from "../common/Buttons";
import DisplaySettingsEditor from "./DisplaySettingsEditor";

import { withTranslation, WithTranslation } from "react-i18next";
import LanguageSelector from "../common/LanguageSelector";

//TODO: remove these when the add work menu is actually implemented.
import newWorkIcon from "../../../icons/ButtonNewWork.png";
import newWorkIconHover from "../../../icons/ButtonNewWorkHover.png";
import newWorkIconPressed from "../../../icons/ButtonNewWorkPressed.png";
import newWorkIconDisabled from "../../../icons/ButtonNewWorkDisabled.png";
import editWorkIcon from "../../../icons/ButtonEditWork.png";
import editWorkIconHover from "../../../icons/ButtonEditWorkHover.png";
import editWorkIconPressed from "../../../icons/ButtonEditWorkPressed.png";
import editWorkIconDisabled from "../../../icons/ButtonEditWorkDisabled.png";
import IconUndo from "../../../icons/IconUndo.png";
import IconUndoHover from "../../../icons/IconUndoHover.png";
import IconUndoPressed from "../../../icons/IconUndoPressed.png";
import IconUndoDisabled from "../../../icons/IconUndoDisabled.png";
import IconRedo from "../../../icons/IconRedo.png";
import IconRedoHover from "../../../icons/IconRedoHover.png";
import IconRedoPressed from "../../../icons/IconRedoPressed.png";
import IconRedoDisabled from "../../../icons/IconRedoDisabled.png";
import IconRefresh from "../../../icons/IconRefresh.png";
import IconRefreshHover from "../../../icons/IconRefreshHover.png";
import IconRefreshPressed from "../../../icons/IconRefreshPressed.png";
import IconRefreshDisabled from "../../../icons/IconRefreshDisabled.png";
import printIcon from "../../../icons/IconPrint.png";
import printIconHover from "../../../icons/IconPrintHover.png";
import printIconPressed from "../../../icons/IconPrintPressed.png";
import IconCloseGantt from "../../../icons/IconCloseGantt.png";
import IconCloseGanttHover from "../../../icons/IconCloseGanttHover.png";
import IconCloseGanttPressed from "../../../icons/IconCloseGanttPressed.png";
import { connect } from "react-redux";
import { differenceInHours } from "date-fns";
import { RESIZER_THICKNESS, VIEWPORT_TITLE_HEIGHT, SCROLLBAR_WIDTH } from "../../helpers/Const";
import NotificationMessage, { PROGRESS } from "../common/NotificationMessage";
import { iRootState, Dispatch } from "src/rematch/store";
import { Action } from "@rematch/core";
import { WithMsalProps } from "@azure/msal-react/dist/components/withMsal";
import { parseTokenFromQueryString } from "src/backend/helpers/urlHelper";

const imgs = [
  newWorkIcon,
  newWorkIconHover,
  newWorkIconPressed,
  newWorkIconDisabled,
  editWorkIcon,
  editWorkIconHover,
  editWorkIconPressed,
  editWorkIconDisabled,
  printIcon,
  printIconHover,
  printIconPressed,
  IconUndo,
  IconUndoHover,
  IconUndoPressed,
  IconUndoDisabled,
  IconRedo,
  IconRedoHover,
  IconRedoPressed,
  IconRedoDisabled,
  IconRefresh,
  IconRefreshHover,
  IconRefreshPressed,
  IconRefreshDisabled,
  IconCloseGantt,
  IconCloseGanttHover,
  IconCloseGanttPressed,
];

interface ISettingsPanelExternalProps {
  sideBarWidth: number;
  zoomMode: string;
  hourWidth: number;
  startDate: Date;
  endDate: Date;
  scrollToCurrentDay: () => void;
  getTimelineHeights: number[];
  setTimelineHeights: (newHeights) => void;
  setSidebarWidth: (newWidth) => void;
}

interface ISettingsPanelProps extends ISettingsPanelExternalProps, WithMsalProps, WithTranslation {
  fullPrint: boolean;
  allowAddAndEdit: boolean;
  canUndo: boolean;
  canRedo: boolean;
  loading: boolean;
  updating: boolean;
  isOauth2Enabled: boolean;
  isEditAllowed: () => boolean;
  isAddAllowed: () => boolean;
  toggleShowAddWorkBox: () => Action<void,void>;
  toggleShowEditBox: () => Action<void,void>;
  toggleShowConfigurationForm: () => Action<void,void>;
  toggleShowTokenForm: () => Action<void,void>;
  toggleShowUIConfigForm: () => Action<void,void>;
  undo: () => Action<void,void>;
  redo: () => Action<void,void>;
  logout: () => Action<void,void>;
  fetchItemsAsync: (fetch: boolean) => Action<boolean,void>;
  clearUndo: () => Action<void,void>;
  useOauth2: (useOauth2: boolean) => Action<boolean,void>;
  showMessage: (message: string, type: number) => Action<void,void>;
  hideMessage: () => Action<void,void>;
  userName: string;
  vaultName: string;
  isAdmin: boolean;
}

interface ISettingsPanelState {
  userDropDownActive: boolean;
}

class SettingsPanel extends PureComponent<ISettingsPanelProps,ISettingsPanelState> {

  userMenuTriggerRef: React.RefObject<HTMLButtonElement>;
  userMenuContentRef: React.RefObject<HTMLDivElement>;

  constructor(props: ISettingsPanelProps) {
    super(props);
    this.userMenuTriggerRef = createRef<HTMLButtonElement>();
    this.userMenuContentRef = createRef<HTMLDivElement>();
    this.state = {
      userDropDownActive: false
    };
  }

  componentDidMount = () => {
    for (const imgURL of imgs) {
      const img = new Image();
      img.src = imgURL;
    }
    document.addEventListener('mousedown', this.handleClickOutsideUserDropdown);
  };

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutsideUserDropdown);
  };

  handleClickOutsideUserDropdown = (event: MouseEvent) => {
    if (this.userMenuTriggerRef && !this.userMenuTriggerRef.current.contains(event.target as HTMLElement) && 
      this.userMenuContentRef && !this.userMenuContentRef.current.contains(event.target as HTMLElement)) {
      this.setUserDropdown(false);
    }
  };

  setUserDropdown = (active: boolean) => {
    this.setState({
      userDropDownActive: active
    });
  };

  toggleUserDropdown = () => {
    this.setState((prevState: ISettingsPanelState) => {
      //Disable dropdown if url token is used
      const token = parseTokenFromQueryString();
      return { 
        userDropDownActive: token ? prevState.userDropDownActive : !prevState.userDropDownActive
      };
    });
  };

  getFullWidth = (sideBarWidth: number) => {
    const fullDuration = differenceInHours(this.props.endDate, this.props.startDate);
    return sideBarWidth + RESIZER_THICKNESS + this.props.hourWidth * fullDuration;
  };

  printPage = () => {
    const { t } = this.props;
    this.props.showMessage(t("inform.printing"), PROGRESS);

    const oldTimelineHeights = this.props.getTimelineHeights;
    const oldSidebarWidth = this.props.sideBarWidth;

    const newTimelineHeights = [];
    let newSidebarWidth = oldSidebarWidth;
    const elems = document.querySelectorAll(".timeline-root");
    for (let i = 0; i < elems.length; i++) {
      const elem = elems[i];
      const innerContainer: HTMLElement = elem.querySelector(".viewport-container");
      let innerContainerHeight = parseInt(innerContainer.getAttribute("height"));
      if(i < elems.length - 1) {
        innerContainerHeight += RESIZER_THICKNESS;
      }
      const sidebarColumns: HTMLElement = elem.querySelector(".sidebar-columns");
      const sidebarColumnsWidth = parseInt((sidebarColumns.firstChild as HTMLElement).getAttribute("width"));
      if(sidebarColumnsWidth > newSidebarWidth) {
        newSidebarWidth = sidebarColumnsWidth;
      }
      newTimelineHeights.push(innerContainerHeight + 2 * VIEWPORT_TITLE_HEIGHT + SCROLLBAR_WIDTH);
    }

    const options = {
      scale: 2,
      width: undefined,
      onclone: undefined,
    };

    if(this.props.fullPrint) {
      this.props.setTimelineHeights(newTimelineHeights);
      this.props.setSidebarWidth(newSidebarWidth);
      options.width = this.getFullWidth(newSidebarWidth);
      options.onclone = (docClone) => {
        const rootElems = docClone.querySelectorAll(".timeline-root");
        const wantedWidth = this.getFullWidth(newSidebarWidth) + "px";
        for (const elem of rootElems) {
          elem.style.width = wantedWidth;
        }
      };
    }

    //Wait screen to update to new heights
    setTimeout(() => {
      const elem: HTMLCanvasElement = document.querySelector("#timeline-container");
      html2canvas(elem, options).then((canvas) => {

        //Restore screen size
        if(this.props.fullPrint) {
          this.props.setTimelineHeights(oldTimelineHeights);
          this.props.setSidebarWidth(oldSidebarWidth);
        }

        setTimeout(() => {
          const canvasData = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = canvasData;
          link.download = "gantt_timeline.png";
          link.click();
          this.props.hideMessage();
        });
      });
    }, 2000); //Increase timeout if canvas is not fully rendered
  };

  logout = () => {
    const { instance } = this.props.msalContext;
    const isOauth2Enabled = this.props.isOauth2Enabled;
    this.props.logout(); 
    this.props.useOauth2(isOauth2Enabled);
    const account = instance.getActiveAccount();
    if(account) {
      instance.logoutRedirect({account: account});
    }
  };

  confirmLogout = () => {
    const { t } = this.props;
    this.setUserDropdown(false);
    setTimeout(() => {
      if(window.confirm(t("confirm.logout"))) { 
        this.logout(); 
      }
    }, 100);
  };

  showConfigurationForm = () => {
    this.setUserDropdown(false);
    setTimeout(() => {
      this.props.toggleShowConfigurationForm();
    }, 100);
  };

  showTokenForm = () => {
    this.setUserDropdown(false);
    setTimeout(() => {
      this.props.toggleShowTokenForm();
    }, 100);
  };

  showUIConfigForm = () => {
    this.setUserDropdown(false);
    setTimeout(() => {
      this.props.toggleShowUIConfigForm();
    }, 100);
  };

  render() {
    const { t } = this.props;
    const userInfo = `${this.props.userName} @ ${this.props.vaultName}`;
    return (
      <SettingsPanelStyled>
        <SettingsSubPanelStyled width={this.props.sideBarWidth + RESIZER_THICKNESS}>
          {this.props.allowAddAndEdit && this.props.isAddAllowed() ? (
            <SettingsVerticalPanelStyled style={{flexBasis: 150}}>
              <SettingsPanelContainerRow>
                <FlexItem50>
                  <IconSettingsButton50x50
                    onClick={this.props.toggleShowAddWorkBox}
                    image={newWorkIcon}
                    imageHover={newWorkIconHover}
                    imagePressed={newWorkIconPressed}
                    imageDisabled={newWorkIconDisabled}
                  />
                </FlexItem50>
                <SettingsSpan>{t("editor.add")}</SettingsSpan>
              </SettingsPanelContainerRow>
            </SettingsVerticalPanelStyled>
          ) : null}
          {this.props.allowAddAndEdit && this.props.isEditAllowed() ? (
            <SettingsVerticalPanelStyled style={{flexBasis: 150}}>
              <SettingsPanelContainerRow>
                <FlexItem50>
                  <IconSettingsButton50x50
                    onClick={this.props.toggleShowEditBox}
                    image={editWorkIcon}
                    imageHover={editWorkIconHover}
                    imagePressed={editWorkIconPressed}
                    imageDisabled={editWorkIconDisabled}
                  />
                </FlexItem50>
                <SettingsSpan>{t("editor.modify")}</SettingsSpan>
              </SettingsPanelContainerRow>
            </SettingsVerticalPanelStyled>
          ) : null}
          <SettingsVerticalPanelStyled style={{flexBasis: 160, paddingLeft:20, marginLeft:"auto"}} >
            <DisplaySettingsEditor />
          </SettingsVerticalPanelStyled>
        </SettingsSubPanelStyled>

        <SettingsSubPanelStyled>
          <SettingsVerticalPanelStyled style={{flexBasis: 270}}>
            <DateRangePickerWrapper scrollToCurrentDay={this.props.scrollToCurrentDay} />
          </SettingsVerticalPanelStyled>

          <SettingsVerticalPanelStyled style={{flexBasis: 332, paddingLeft:20, flexShrink:0}}>
            <ZoomModeSelector zoomMode={this.props.zoomMode} />
          </SettingsVerticalPanelStyled>
          
        </SettingsSubPanelStyled>
        <SettingsSubPanelStyled /*width={195}*/>
          <SettingsVerticalPanelStyled style={{marginLeft:"auto"}}>
            <SettingsPanelContainerColumn>
              <SettingsPanelContainerRow style={{ alignSelf: "flex-end", paddingTop: 15 }}>
                <FlexItem>
                  <LanguageSelector />
                </FlexItem>
                <FlexItem22 style={{marginLeft:17}}>
                  <IconSettingsButton22x22
                    image={IconUndo}
                    imageHover={IconUndoHover}
                    imagePressed={IconUndoPressed}
                    imageDisabled={IconUndoDisabled}
                    onClick={this.props.undo}
                    disabled={this.props.canUndo === false}
                  />
                </FlexItem22>
                <FlexItem22 style={{marginLeft:17}}>
                  <IconSettingsButton22x22
                    image={IconRedo}
                    imageHover={IconRedoHover}
                    imagePressed={IconRedoPressed}
                    imageDisabled={IconRedoDisabled}
                    onClick={this.props.redo}
                    disabled={this.props.canRedo === false}
                  />
                </FlexItem22>
                <FlexItem22 style={{marginLeft:17}}>
                  <IconSettingsButton22x22
                    onClick={this.printPage}
                    image={printIcon}
                    imageHover={printIconHover}
                    imagePressed={printIconPressed}
                  />
                </FlexItem22>
                <FlexItem22 style={{marginLeft:17}}>
                  <IconSettingsButton22x22
                    onClick={() => {
                      this.props.clearUndo();
                      this.props.fetchItemsAsync(false);
                    }}
                    image={IconRefresh}
                    imageHover={IconRefreshHover}
                    imagePressed={IconRefreshPressed}
                    imageDisabled={IconRefreshDisabled}
                    disabled={this.props.loading || this.props.updating}
                  ></IconSettingsButton22x22>
                </FlexItem22>
                <FlexItem22 style={{marginLeft:17}}>
                  <IconSettingsButton22x22
                    onClick={this.confirmLogout}
                    image={IconCloseGantt}
                    imageHover={IconCloseGanttHover}
                    imagePressed={IconCloseGanttPressed}
                  />
                </FlexItem22>
                <SettingsSpan />
              </SettingsPanelContainerRow>
              <SettingsPanelContainerRow style={{ alignSelf: "flex-start", paddingTop: 5, paddingRight: 5 }}>
                <FlexItem>
                  <UserMenuTrigger onClick={this.toggleUserDropdown} ref={this.userMenuTriggerRef} title={userInfo}>{userInfo}</UserMenuTrigger>
                  <UserMenuContent style={{visibility: this.state.userDropDownActive ? "visible" : "hidden"}} ref={this.userMenuContentRef}>
                    <UserMenuItem><UserMenuLink onClick={this.showTokenForm}>{t("usermenu.loginlink")}</UserMenuLink></UserMenuItem>
                    {this.props.isAdmin && <UserMenuItem><UserMenuLink onClick={this.showConfigurationForm}>{t("usermenu.configuration")}</UserMenuLink></UserMenuItem>}
                    {this.props.isAdmin && <UserMenuItem><UserMenuLink onClick={this.showUIConfigForm}>{t("usermenu.uiconfig")}</UserMenuLink></UserMenuItem>}
                    <UserMenuItem><UserMenuLink onClick={this.confirmLogout}>{t("usermenu.logout")}</UserMenuLink></UserMenuItem>
                  </UserMenuContent>
                </FlexItem>
              </SettingsPanelContainerRow>
            </SettingsPanelContainerColumn>
          </SettingsVerticalPanelStyled>
        </SettingsSubPanelStyled>
        <NotificationMessage />
      </SettingsPanelStyled>
    );
  }
}

const mapState = (state: iRootState) => ({
  fullPrint: state.UI.displaySettings.fullPrint,
  allowAddAndEdit: state.UI.displaySettings.allowAddAndEdit,
  canUndo: state.history.past.length > 0,
  canRedo: state.history.future.length > 0,
  loading: state.items.loading,
  updating: state.items.updating,
  isOauth2Enabled: state.common.isOauth2Enabled,
  isEditAllowed: () => {
    if(state.items.selectedItem === null) {
      return false;
    }
    const item = state.items.allData[state.items.selectedItem];
    return (!item.isCheckedOut || item.isCheckedOutToThisUser) && state.common.configuration.objectTypeConfigurations.get(item.objectType).mayEdit;
  },
  isAddAllowed: () => Array.from(state.common.configuration.objectTypeConfigurations.values()).filter(i => i.mayEdit === true).length > 0,
  userName: state.common.configuration.userName,
  vaultName: state.common.configuration.vaultName,
  isAdmin: state.common.configuration.isAdmin,
});

const mapDispatch = (dispatch: Dispatch) => ({
  toggleShowAddWorkBox: dispatch.UI.toggleShowAddWorkBox,
  toggleShowEditBox: dispatch.UI.toggleShowEditBox,
  toggleShowConfigurationForm: dispatch.UI.toggleShowConfigurationForm,
  toggleShowTokenForm: dispatch.UI.toggleShowTokenForm,
  toggleShowUIConfigForm: dispatch.UI.toggleShowUIConfigForm,
  undo: dispatch.history.undoAsync,
  redo: dispatch.history.redoAsync,
  logout: dispatch.common.logout,
  fetchItemsAsync: dispatch.items.fetchItemsAsync,
  clearUndo: dispatch.history.clear,
  useOauth2: dispatch.common.useOauth2,
  showMessage: dispatch.UI.showMessage,
  hideMessage: dispatch.UI.hideMessage,
});

export default withTranslation()(withMsal(connect(mapState, mapDispatch)(SettingsPanel))) as ComponentType<ISettingsPanelExternalProps>;
